import { render, staticRenderFns } from "./Home2021.vue?vue&type=template&id=3781b07c"
import script from "./Home2021.vue?vue&type=script&lang=js"
export * from "./Home2021.vue?vue&type=script&lang=js"
import style0 from "./Home2021.vue?vue&type=style&index=0&id=3781b07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports